import { Api, getSession } from '../api/Assinafy'
import { getPendingRedirectWithAction } from './accountPendingActions'

const resolveLoginRedirect = async () => {
  const accountId = getSession()?.accounts?.[0]?.id
  if (!accountId) {
    return null
  }

  const pendingApi = Api('account/pendingActions')
  if (!pendingApi) {
    return null
  }

  try {
    const response = await pendingApi(accountId)
    if (response?.status !== 200) {
      return null
    }

    const actions = response?.data?.data?.actions
    return getPendingRedirectWithAction(actions, accountId)
  } catch {
    return null
  }
}

const navigateAfterLogin = async (navigate) => {
  const redirect = await resolveLoginRedirect()
  if (redirect?.path && redirect?.action?.id) {
    navigate(redirect.path, {
      replace: true,
      state: {
        pendingActionResolve: {
          accountId: getSession()?.accounts?.[0]?.id,
          actionId: redirect.action.id,
          type: redirect.action.type,
        },
      },
    })
    return
  }

  navigate('/dashboard', { replace: true })
}

export { navigateAfterLogin, resolveLoginRedirect }
